import { MoocState } from '@/constant/moocTupe'

export const state: MoocState = {
  navConfig: {
   logo:'',
   schoolName:''
  }
}
